import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { VersionNavigation } from "@/components/VersionNavigation";
import NamesCleanerPage from "./NamesCleanerPage";

const Gomb7Page = () => {
    const { gameId, versionId } = useParams();

    const { data: gameDetails } = useQuery({
        queryKey: ["gameDetails", gameId],
        queryFn: async () => {
            const response = await fetch(`/api/games/${gameId}`);
            if (!response.ok) throw new Error("Failed to fetch game details");
            return response.json();
        },
        enabled: !!gameId,
    });

    const { data: versionDetails } = useQuery({
        queryKey: ["versionDetails", gameId, versionId],
        queryFn: async () => {
            const response = await fetch(`/api/games/${gameId}/versions/${versionId}`);
            if (!response.ok) throw new Error("Failed to fetch version details");
            return response.json();
        },
        enabled: !!gameId && !!versionId,
    });

    return (
        <div className="p-8">
            <Breadcrumb className="mb-8">
                <BreadcrumbList>
                    <BreadcrumbItem>
                        <BreadcrumbLink asChild>
                            <Link to="/games">Játékok</Link>
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <BreadcrumbLink asChild>
                            <Link to={`/games/${gameId}`}>{gameDetails?.name}</Link>
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <BreadcrumbLink asChild>
                            <Link to={`/games/${gameId}/versions/${versionId}`}>
                                Verzió: {versionDetails?.name}
                            </Link>
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <span>Lista</span>
                    </BreadcrumbItem>
                </BreadcrumbList>
            </Breadcrumb>
            <VersionNavigation gameId={gameId} versionId={versionId} />

            <NamesCleanerPage gameId={gameId} versionId={versionId} />
        </div>
    );
};

export default Gomb7Page;
